module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/data-second-bg.de2e6b43.png";